import { css } from '@emotion/core'
import { mqMin, TxtLimit } from '@styles/base.style'
import styled, { Theme } from '@themes/theme'

export const DateSpan = styled.p`
  color: ${props => props.theme.color.modalSubTxt};
`
export const ListItemTitle = styled.div`
  color: ${props => props.theme.color.modalTxt};
  display: inline-block;
  width: 100%;
  margin: 0 0 4px;
  font-size: ${props => props.theme.font.large};
`
export const ListItemWrap = (theme: Theme) => css`
  line-height: 1.4rem;
  font-size: ${theme.font.small};
  &:nth-of-type(2)::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    display: block;
    width: 90%;
    height: 25px;
    border-right: ${theme.border.line};
  }
`
export const DummyStyle = css`
  display: block;
  margin: 0 auto;
  width: 25px;
`
export const SellerName = styled.span`
  display: block;
  color: ${props => props.theme.color.modalTxt};
  font-size: ${props => props.theme.font.small};
`
export const Txt = styled.span`
  display: block;
  color: ${props => props.theme.color.modalSubTxt};
  font-size: ${props => props.theme.font.small};
`
export const Num = styled.span`
  width: 100%;
  display: inline-block;
  color: ${props => props.theme.color.modalTxt};
  &.pick-popup {
    width: 92%;
    text-align: right;
  }
`
export const Money = styled.span`
  width: 86%;
  display: inline-block;
  text-align: right;
  color: ${props => props.theme.color.modalTxt};
`
export const GmoneyStyle = styled.span`
  position: relative;
  float: right;
  width: 12%;
  ${mqMin[2]} {
    width: 8%;
  }
  svg {
    position: absolute;
    right: 0;
    width: 12px;
  }
`
//  메시지함 팝업
export const PopupBtnStyle = (theme: Theme) => css`
  position: relative;
  width: 100%;
  height: 36px;
  margin-top: 14px;
  font-size: ${theme.font.medium};
  background-color: ${theme.color.secondaryBg};
  border: 1px solid ${theme.color.secondaryBg};
  border-radius: 20px;
  &.two-button {
    left: 3.5px;
    width: calc(100% - 7px);
    height: 30px;
    margin-top: 30px;
    &.cancel {
      left: -3.5px;
      background-color: ${theme.color.btn};
      border: 1px solid ${theme.color.btn};
    }
  }
`
export const PopupTxt = styled.p`
  color: ${props => props.theme.color.modalTxt};
  span {
    float: none;
    width: auto;
    svg {
      position: relative;
      top: 2px;
      margin: 0 2px;
    }
  }
`
// ////////////////////////////////// 클럽 쪽지 ////////////////////////////////////
export const MessageWrap = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  &::before {
    content: '';
    display: block;
    position: absolute;
    top: 22px;
    left: 0;
    width: 100%;
    height: 27px;
    border-top: 1px solid ${props => props.theme.color.modalSubBg};
    border-bottom: 1px solid ${props => props.theme.color.modalSubBg};
  }
  // 클럽 정보 모달 - 공지 팝업
  &.club-notice-popup {
    &::before {
      display: none;
    }
    .club-notice-popup-tit {
      ${TxtLimit};
      height: 26px;
      border-bottom: 1px solid ${props => props.theme.color.modalSubBg};
      .notice-tag, .event-tag {
        line-height: 2rem;
        margin-right: 6px;
      }
      // 공지사항 타이틀
      .notice-tag {
        display: inline-block;
      }
      .event-tag {
        display: none;
      }
      // 이벤트 타이틀
      &.event-tit {
        .notice-tag {
          display: none;
        }
        .event-tag {
          display: inline-block;
        }
      }
    }
    .club-notice-popup-content {
      min-height: 165px;
      height: auto;
      max-height: 56vh;
      overflow: auto;
      font-weight: ${props => props.theme.fontW.medium};
    }
  }
`
export const SendBtnStyle = (theme: Theme) => css`
  position: relative;
  left: -14px;
  bottom: 0;
  width: 100vw;
  height: 36px;
  border-radius: 0;
`
const CommonStyle = css`
  float: left;
  text-align: left;
`
export const Club = styled.span`
  ${CommonStyle};
  margin-bottom: 10px;
  color: ${props => props.theme.color.modalSubTxt};
`
export const ClubName = styled.span`
  ${CommonStyle};
  width: calc(50% - 10px);
  color: ${props => props.theme.color.modalTxt};
`
export const Date = styled.span`
  width: calc(50% - 50px);
  text-align: right;
  color: ${props => props.theme.color.modalSubTxt};
`
export const Title = styled.p`
  ${CommonStyle};
  width: 100%;
  margin-bottom: 10px;
  color: ${props => props.theme.color.modalTxt};
`
export const Content = styled.p`
  ${CommonStyle};
  width: 100%;
  height: 165px;
  margin-bottom: 6px;
  overflow: scroll;
  color: ${props => props.theme.color.modalTxt};
  white-space: pre-wrap;
`
